export default __webpack_public_path__ + "images/a174589c1a76f60fca6157c358309226-dont_5.png";